import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ApiStatus } from 'common/enums';

import initialDataEditorState from './dataEditor.state';

const dataEditorSlice = createSlice({
    name: 'dataEditor',
    initialState: initialDataEditorState,
    reducers: {
        setMode: (state, { payload }: PayloadAction<string>) => {
            state.mode = payload;
        },
        resetState: () => {
            return initialDataEditorState;
        },
        setMessageGuide: (state, { payload }: PayloadAction<any>) => {
            state.messageGuide.isVisible = payload.isVisible;
            state.messageGuide.message = payload.message;
        },
        setMessageBanner: (state, { payload }: PayloadAction<any>) => {
            state.messageBanner.isVisible = payload.isVisible;
            state.messageBanner.message = payload.message;
        },
        loadToMasterData: (state) => {
            state.loadToMasterDataApiStatus = ApiStatus.LOADING;
        },
        loadToMasterDataSuccess: (state, { payload }: PayloadAction<any>) => {
            state.loadToMasterDataApiStatus = ApiStatus.SUCCESS;
        },
        loadToMasterDataFailed: (state) => {
            state.loadToMasterDataApiStatus = ApiStatus.ERROR;
        },
        clearPreview: (state) => {
            state.clearPreview.status = ApiStatus.LOADING;
        },
        clearPreviewSuccess: (state, { payload }: PayloadAction<any>) => {
            state.clearPreview.status = ApiStatus.SUCCESS;
        },
        clearPreviewFailed: (state) => {
            state.clearPreview.status = ApiStatus.ERROR;
        },
        resetClearPreview: (state) => {
            state.clearPreview = {};
        }
    }
});

export default dataEditorSlice.reducer;
export const dataEditorActions = dataEditorSlice.actions;
